import * as Yup from 'yup';
import servicesIaFormModel from './servicesIaFormModel';

const {
    formField: {
        provider,
        serviceType,
        name,
        code,
        description,
        apiVersion,
        currency,
        inputPrice,
        outputPrice,
        cachePrice,
        contextWindow,
        maxOutputTokens,
        sortOrder
    }
} = servicesIaFormModel;

export default [
    Yup.object().shape({
        [provider.name]: Yup.object().shape({
            value: Yup.string().required(),
            label: Yup.string().required()
        }).default(undefined).required(provider.requiredErrorMsg),
        [serviceType.name]: Yup.object().shape({
            value: Yup.string().required(),
            label: Yup.string().required()
        }).default(undefined).required(serviceType.requiredErrorMsg),
        [name.name]: Yup.string().required(name.requiredErrorMsg),
        [code.name]: Yup.string().required(code.requiredErrorMsg).matches(/^[a-z0-9._-]+$/, 'Solo minúsculas, números, puntos y guiones'),
        [description.name]: Yup.string().optional(),
        [apiVersion.name]: Yup.string().optional(),
        [currency.name]: Yup.object().shape({
            value: Yup.string().required(),
            label: Yup.string().required()
        }).nullable().optional(),
        [inputPrice.name]: Yup.number().typeError('Debe ser un número').optional().nullable(),
        [outputPrice.name]: Yup.number().typeError('Debe ser un número').optional().nullable(),
        [cachePrice.name]: Yup.number().typeError('Debe ser un número').optional().nullable(),
        [contextWindow.name]: Yup.number().typeError('Debe ser un número').optional().nullable(),
        [maxOutputTokens.name]: Yup.number().typeError('Debe ser un número').optional().nullable(),
        [sortOrder.name]: Yup.number().typeError('Debe ser un número').optional().nullable(),
    })
];
